// An asset's bytes, as a link to hand the browser.

import { api } from '../client'
import type { components } from '../schema'

export type CreateDownloadRequest = components['schemas']['CreateDownloadRequest']
export type DownloadMinted = components['schemas']['DownloadMinted']

/**
 * A signed link to an asset's source — at its current generation unless `version` names another —
 * or to one of its files. The link expires: ask again rather than keep it. 404 for a generation
 * whose bytes never landed.
 */
export function createDownload(request: CreateDownloadRequest): Promise<DownloadMinted> {
  return api.post<DownloadMinted>('/downloads', request)
}
